import { matchPath } from "react-router";
import { SETTINGS_ROUTES } from "../../../../consts/routes";
import { BLOCK_FIELDS } from "./config";
import { removeNullishFromShape } from "../../../../utilities/general";
import { SURVEY_TYPE } from "../../../../api/surveys/config";

export const getPathParams = () => {
  const match = matchPath(window.location.pathname, {
    path: SETTINGS_ROUTES.editSurveyTemplate(":id"),
    exact: true,
    strict: false,
  });

  const surveyId = Number(match?.params?.id || "0");

  return {
    surveyId,
    isEditMode: Boolean(surveyId),
  };
};

export const blockAdapter = {
  send: (block, index, isEditMode) => {
    const id = block[BLOCK_FIELDS.id];
    return removeNullishFromShape({
      id: isEditMode && typeof id === "number" ? id : null,
      boxtype: block[BLOCK_FIELDS.type],
      description: block[BLOCK_FIELDS.isDescriptionRequired] || false,
      descriptionText: block[BLOCK_FIELDS.description] || "",
      displayOrder: index + 1,
      name: block[BLOCK_FIELDS.question] || "",
      options: block[BLOCK_FIELDS.choices] || [],
      required: block[BLOCK_FIELDS.isRequired] || false,
      why_choose: block[BLOCK_FIELDS.commentsOnScale] || false,
    });
  },
  receive: (block) => ({
    [BLOCK_FIELDS.id]: block.id,
    [BLOCK_FIELDS.type]: block.boxtype,
    [BLOCK_FIELDS.question]: block.name,
    [BLOCK_FIELDS.choices]: block.options || [],
    [BLOCK_FIELDS.isRequired]: block.required || false,
    [BLOCK_FIELDS.isDescriptionRequired]: block.description || false,
    [BLOCK_FIELDS.description]: block.descriptionText || "",
    [BLOCK_FIELDS.commentsOnScale]: block.why_choose || false,
  }),
};

export var titleValid = (title) => (!title?.trim() ? "titleRequired" : null);

export var questionsLengthValid = (questions) =>
  questions.length === 0 ? "questionRequired" : null;

export var questionsChoicesValid = (questions) => {
  const options = questions
    .filter((block) =>
      [SURVEY_TYPE.singleChoice, SURVEY_TYPE.multipleChoice].includes(
        block.boxtype,
      ),
    )
    .map((block) => block.options);

  if (
    options
      .map((x) => x.map((y) => y?.trim()))
      .some((x) => x.filter(Boolean).length === 0)
  ) {
    return "questionChoicesRequired";
  }

  if (options.some((list) => list.length !== new Set(list).size)) {
    return "duplicateChoices";
  }

  return null;
};

export var questionNamesValid = (questions) => {
  const names = questions.map((block) => block.name);
  if (names.some((name) => !name)) {
    return "questionNameRequired";
  }
  if (names.length !== new Set(names).size) {
    return "duplicateQuestionNames";
  }
  return null;
};
